const SCROLL_INTERVAL = 400; // 标题滚动间隔（毫秒）。
const SCROLL_SEPARATOR = "  -  "; // 循环衔接符，避免首尾文字粘连。

let pageTitle = ""; // 当前路由对应的基础标题。
let scrollContent = ""; // 正在滚动的通知文案，用于判断内容是否变化。
let scrollOffset = 0; // 当前滚动位置。
let scrollTimer = null; // 滚动定时器。

/**
 * 归一化标题文本，折叠换行和连续空格。
 * @param {*} text 原始文本
 * @returns {string}
 */
function normalizeTitle(text) {
  return String(text == null ? "" : text).replace(/\s+/g, " ").trim();
}

/**
 * 渲染一帧滚动标题。
 * @returns {void}
 */
function renderTitleFrame() {
  if (!scrollContent) return;

  // 每次渲染时拼接循环衔接符，方便 startTitleScroll 用原始内容判断是否变化。
  // 用 Array.from 按码点切分，避免把 emoji 等代理对拆成乱码。
  const chars = Array.from(`${scrollContent}${SCROLL_SEPARATOR}`);
  const length = chars.length;
  document.title = chars.slice(scrollOffset).join("") + chars.slice(0, scrollOffset).join("");
  scrollOffset = (scrollOffset + 1) % length;
}

/**
 * 设置页面基础标题，路由切换时调用。
 * 通知滚动期间只更新基础标题，不打断滚动。
 * @param {string} title 页面标题
 * @returns {void}
 */
export function setPageTitle(title) {
  if (typeof document === "undefined") return;
  const nextTitle = normalizeTitle(title);
  if (!nextTitle) return;
  pageTitle = nextTitle;
  if (!scrollTimer) {
    document.title = pageTitle;
  }
}

/**
 * 开始或更新通知标题滚动。
 * @param {string} content 通知内容
 * @returns {void}
 */
export function startTitleScroll(content) {
  if (typeof document === "undefined") return;
  const nextContent = normalizeTitle(content);
  if (!nextContent) return;

  // 路由还没设置过标题时，以当前标题作为兜底，保证关闭通知后能恢复。
  if (!pageTitle) {
    pageTitle = normalizeTitle(document.title);
  }

  // 内容没变时不重置 offset，避免重复推送导致标题反复跳回开头。
  if (nextContent === scrollContent && scrollTimer) return;
  scrollContent = nextContent;
  scrollOffset = 0;
  if (!scrollTimer) {
    scrollTimer = window.setInterval(renderTitleFrame, SCROLL_INTERVAL);
  }
  renderTitleFrame();
}

/**
 * 停止通知标题滚动并恢复页面标题。
 * @returns {void}
 */
export function stopTitleScroll() {
  if (typeof document === "undefined") return;
  if (scrollTimer) {
    clearInterval(scrollTimer);
    scrollTimer = null;
  }
  scrollContent = "";
  scrollOffset = 0;
  if (pageTitle) {
    document.title = pageTitle;
  }
}